<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 100%">
                <el-row class="filter-bar" ref="filterBar">
                    <el-radio-group v-model="viewMode" size="mini" style="" @change="handleViewChange">
                        <el-radio-button label="list">券池记录</el-radio-button>
                        <el-radio-button label="unknown">扣减异常</el-radio-button>
                    </el-radio-group>
                    <template v-if="viewMode === 'list'">
                        <el-input v-model="formDatas.acrCode" style="width: 120px;" size="mini" placeholder="劵码"
                            clearable></el-input>
                    <el-input v-model="formDatas.acrPhone" style="width: 120px;" size="mini" placeholder="手机号"
                        clearable></el-input>
                    <el-input v-model="formDatas.acrAmount" style="width: 100px;" size="mini" placeholder="劵面金额"
                        clearable></el-input>
                    <el-date-picker v-model="formDatas.acrYearMonth" type="month" placeholder="选择年月"
                        style="width: 130px;" size="mini" clearable value-format="yyyyMM"
                        @change="partserch"></el-date-picker>
                    <el-select v-model="formDatas.acrCodeType" placeholder="请选择券码类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="烟感" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.billShareType" placeholder="请选择分账类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option v-for="item in billShareTypeList" :key="item.asShareTypeId"
                            :label="item.asShareTypeName" :value="item.asShareTypeId"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.acrStatus" placeholder="请选择状态" style="width: 140px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="已撤销" :value="0"></el-option>
                        <el-option label="创建" :value="1"></el-option>
                        <el-option label="第三方导入" :value="2"></el-option>
                        <el-option label="第三方领取" :value="3"></el-option>
                        <el-option label="已核销" :value="4"></el-option>
                        <el-option label="分账" :value="5"></el-option>
                        <el-option label="退款" :value="6"></el-option>
                        <el-option label="挂起" :value="8"></el-option>
                    </el-select>
                    <!-- 后端列表/导出接口新增的商户维度筛选:地市->区县级联 + 商户id -->
                    <el-select size="mini" v-model="formDatas.ascId" clearable @change="cityChange"
                        placeholder="请选择商户地市" style="width: 130px;">
                        <el-option v-for="item in getAjefShopCityList_data" :key="item.ascId" :label="item.ascName"
                            :value="item.ascId"></el-option>
                    </el-select>
                    <el-select size="mini" v-if="formDatas.ascId" v-model="formDatas.ascdId" clearable
                        @change="partserch" placeholder="请选择商户区县" style="width: 130px;">
                        <el-option v-for="item in getAjefShopCityDistrictList_data" :key="item.ascdId"
                            :label="item.ascdName" :value="item.ascdId"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.asId" style="width: 100px;" size="mini"
                        placeholder="商户id" clearable></el-input>
                    <div class="filter-actions">
                        <el-button type="info" size="mini" icon="el-icon-search" @click="partserch">搜索</el-button>
                        <el-button type="warning" size="mini" icon="el-icon-download" @click="handleExport">导出</el-button>
                    </div>
                    </template>
                    <template v-else>
                        <el-input v-model="unknownFormDatas.acrCode" style="width: 180px;" size="mini" placeholder="券码"
                            clearable></el-input>
                        <el-input v-model="unknownFormDatas.acrPhone" style="width: 140px;" size="mini"
                            placeholder="领取手机号" clearable></el-input>
                        <div class="filter-actions">
                            <el-button type="info" size="mini" icon="el-icon-search" @click="unknownSearch">搜索</el-button>
                        </div>
                    </template>
        </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="currentColumns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="currentForm.currentPage"
                        :page-size="currentForm.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordSubList, getAjefShopBillShareTypeList, updateAjefCertificateRecordSubRefund, getAjefShopCityList, getAjefShopCityDistrictList, getAjefCertificateRecordSubUnknownList, updateAjefCertificateRecordSubUnknownResolve, getAjefCertificateRecordSubUnknownRefresh } from "../../api/api";
export default {
    name: "CertificateRecordSub",
    components: {},
    data() {
        return {
            // 分账类型列表
            billShareTypeList: [],
            // 商户地市/区县列表(筛选用)
            getAjefShopCityList_data: [],
            getAjefShopCityDistrictList_data: [],
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrCode",
                    key: "acrCode",
                    title: "劵码",
                    align: "center",
                    width: 180,
                },
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "劵面金额(元)",
                    align: "center",
                },
                {
                    field: "acrYearMonth",
                    key: "acrYearMonth",
                    title: "年月",
                    align: "center",
                },
                {
                    field: "acrCodeType",
                    key: "acrCodeType",
                    title: "劵码类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrCodeType == 1) {
                            return '普通'
                        } else if (row.acrCodeType == 2) {
                            return '烟感'
                        } else if (row.acrCodeType == 3) {
                            return '类型3'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "billShareType",
                    key: "billShareType",
                    title: "分账类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const typeItem = this.billShareTypeList.find(item => item.asShareTypeId === row.billShareType);
                        return typeItem ? typeItem.asShareTypeName : '';
                    },
                },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrStatus == 0) {
                            return '已撤销'
                        } else if (row.acrStatus == 1) {
                            return '创建'
                        } else if (row.acrStatus == 2) {
                            return '第三方导入'
                        } else if (row.acrStatus == 3) {
                            return '第三方领取'
                        } else if (row.acrStatus == 4) {
                            return '已核销'
                        } else if (row.acrStatus == 5) {
                            return '分账'
                        } else if (row.acrStatus == 6) {
                            return '退款'
                        } else if (row.acrStatus == 8) {
                            return '挂起'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "acrPhone",
                    key: "acrPhone",
                    title: "领取手机号",
                    align: "center",
                    width: 140,
                },
                {
                    field: "acrGetTime",
                    key: "acrGetTime",
                    title: "领取时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "",
                    key: "operation",
                    title: "操作",
                    align: "center",
                    width: 80,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrStatus == 3) {
                            return h(
                                'el-button',
                                {
                                    props: {
                                        type: 'text',
                                        size: 'mini'
                                    },
                                    style: {
                                        color: '#F56C6C'
                                    },
                                    on: {
                                        click: () => {
                                            this.handleRefund(row);
                                        }
                                    }
                                },
                                '退款'
                            );
                        }
                        return '';
                    },
                },
                // {
                //     field: "createTime",
                //     key: "h",
                //     title: "创建时间",
                //     width: 160,
                //     align: "center",
                // },
            ],
            // 扣减异常视图列(券池列见上方columns)
            unknownColumns: [
                {
                    field: "",
                    key: "ua",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrCode",
                    key: "uacrCode",
                    title: "券码",
                    align: "center",
                    width: 180,
                },
                {
                    field: "couponSourceDes",
                    key: "ucouponSourceDes",
                    title: "券来源",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row }, h) => {
                        const isBeiguo = row.couponSourceDes === "北国";
                        return h('span', { style: { color: isBeiguo ? '#E6A23C' : '#909399' } }, row.couponSourceDes || '');
                    },
                },
                {
                    field: "acrAmount",
                    key: "uacrAmount",
                    title: "券面金额(元)",
                    align: "center",
                },
                {
                    field: "specsName",
                    key: "uspecsName",
                    title: "规格",
                    align: "center",
                },
                {
                    field: "acrPhone",
                    key: "uacrPhone",
                    title: "领取手机号",
                    align: "center",
                    width: 140,
                },
                {
                    field: "acrGetTime",
                    key: "uacrGetTime",
                    title: "领取时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "deductStatusDes",
                    key: "udeductStatusDes",
                    title: "扣减记录",
                    align: "center",
                    renderBodyCell: ({ row }, h) => {
                        const color = row.deductStatusDes === "有记录-成功" ? "#67C23A"
                            : row.deductStatusDes === "有记录-失败" ? "#F56C6C" : "#909399";
                        return h('span', { style: { color } }, row.deductStatusDes || '');
                    },
                },
                {
                    field: "resolveAdviceDes",
                    key: "uresolveAdviceDes",
                    title: "处置建议",
                    align: "center",
                    width: 220,
                },
                {
                    field: "",
                    key: "uoperation",
                    title: "操作",
                    align: "center",
                    width: 210,
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        //北国券非池券,第二个动作是"作废撤券"(本地作废+撤销北国卡券),不是回池
                        const isBeiguo = row.couponSourceDes === "北国";
                        return h('div', [
                            h(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'mini' },
                                    style: { color: '#67C23A' },
                                    on: { click: () => { this.handleResolve(row, 1); } }
                                },
                                '恢复已领取'
                            ),
                            h(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'mini' },
                                    style: { color: '#E6A23C' },
                                    on: { click: () => { this.handleResolve(row, 2); } }
                                },
                                isBeiguo ? '作废撤券' : '回池'
                            ),
                            h(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'mini' },
                                    style: { color: '#409EFF' },
                                    on: { click: () => { this.handleRefreshDeduct(row); } }
                                },
                                '刷新记录'
                            ),
                        ]);
                    },
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
            // 视图模式:list=券池记录 unknown=扣减异常(H5领券扣减结果未知被挂起的券)
            viewMode: "list",
            unknownFormDatas: {
                acrCode: "",
                acrPhone: "",
                currentPage: 1,
                pageSize: 10,
            },
            tableLoading: false,
            totalCount: 100,
        };
    },
    computed: {
        currentColumns() {
            return this.viewMode === "unknown" ? this.unknownColumns : this.columns;
        },
        currentForm() {
            return this.viewMode === "unknown" ? this.unknownFormDatas : this.formDatas;
        },
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = calcTableHeight(this, this.windheight, 140);
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = calcTableHeight(this, val, 140);
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = calcTableHeight(this, this.windheight, 140);
        this.getBillShareTypeList();
        // 加载商户地市列表(区县按地市级联加载)
        getAjefShopCityList({ pageSize: 0 }).then(res => {
            this.getAjefShopCityList_data = res.data || [];
        });
        this.getList();
    },
    mounted() { },
    methods: {
        // 获取分账类型列表
        getBillShareTypeList() {
            getAjefShopBillShareTypeList().then(res => {
                this.billShareTypeList = res.data || [];
            });
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleExport() {
            // 与 getList 一致的参数清理,保证新增的商户维度筛选能正确跟随导出
            const params = { ...this.formDatas };
            ['ascId', 'ascdId', 'asId'].forEach(k => {
                if (params[k] === '' || params[k] === null) delete params[k];
            });
            var s = qs.stringify(params);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-sub/exportAjefCertificateRecordSub',
                data: s,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '未领取的券.xlsx');
                    a.click();
                    that.$message({
                        message: "导出成功",
                        type: "success"
                    });
                }
            })
        },
        pageSizeChange(pageSize) {
            this.currentForm.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.currentForm.currentPage = pageIndex;
            this.fetchCurrent();
        },
        partserch() {
            this.currentForm.currentPage = 1;
            this.fetchCurrent();
        },
        // 按当前视图拉取列表
        fetchCurrent() {
            if (this.viewMode === "unknown") {
                this.getUnknownList();
            } else {
                this.getList();
            }
        },
        // 视图切换
        handleViewChange() {
            this.currentForm.currentPage = 1;
            this.fetchCurrent();
        },
        // 扣减异常-搜索
        unknownSearch() {
            this.unknownFormDatas.currentPage = 1;
            this.getUnknownList();
        },
        // 扣减异常-列表
        getUnknownList() {
            this.tableLoading = true;
            const params = { ...this.unknownFormDatas };
            getAjefCertificateRecordSubUnknownList(params).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data || [];
                this.totalCount = res.total || 0;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        // 扣减异常-处置(1恢复已领取 2回池/北国券作废撤券)
        handleResolve(row, resolveType) {
            const isBeiguo = row.couponSourceDes === "北国";
            if (resolveType === 1) {
                // 恢复已领取(2026-10-08):先粘贴移动侧该笔扣减流水JSON,后端按流水补建扣减记录(对账/回退依赖)再恢复券
                this.$prompt(
                    "请粘贴移动侧该笔扣减流水JSON(FLOWTYPE=Deduct,含TRANSIDO/SUBTRANIDO/RECFORMNUM/FLOWAMT)。" +
                    "系统将按流水补建扣减订单记录(金额须与券面一致)后恢复已领取。",
                    "恢复已领取",
                    {
                        confirmButtonText: "补建记录并恢复",
                        cancelButtonText: "取消",
                        inputType: "textarea",
                        inputPlaceholder: '{"TRANSIDO":"...","SUBTRANIDO":"...","RECFORMNUM":"...","FLOWAMT":"36000","FLOWTYPE":"Deduct",...}',
                        inputValidator: (v) => !!(v && v.trim()) || "请粘贴移动侧扣减流水JSON",
                    }
                ).then(({ value }) => {
                    updateAjefCertificateRecordSubUnknownResolve({
                        acrId: row.acrId,
                        resolveType: resolveType,
                        flowJson: value.trim(),
                        operatorName: this.loginOperatorName(),
                    }).then((res) => {
                        if (!res) {
                            // 校验不通过,拦截器已弹出具体原因(流水解析失败/金额不一致/补建失败,券保持挂起)
                            return;
                        }
                        this.$message.success(res.data || "处置成功");
                        this.getUnknownList();
                    });
                }).catch(() => {});
                return;
            }
            const tip = isBeiguo
                ? "作废撤券：本地记录作废并撤销北国卡券(请先确认移动侧未扣款)"
                : "回池：券码将清空领取信息、可被重新领取(请先确认移动侧未扣款)";
            this.$confirm(tip + "。扣减记录列为同步表数据,可能有延迟。", "处置确认", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                updateAjefCertificateRecordSubUnknownResolve({ acrId: row.acrId, resolveType: resolveType }).then((res) => {
                    if (!res) {
                        // 校验不通过,拦截器已弹出具体原因
                        return;
                    }
                    this.$message.success(res.data || "处置成功");
                    this.getUnknownList();
                });
            }).catch(() => {});
        },
        // 操作人名(补建记录留痕用):取本地登录用户(store/index.js登录时写入),取不到给空由后端兜底
        loginOperatorName() {
            return localStorage.getItem("Qy_userName") || "";
        },
        // 扣减异常-单券扣减记录即时刷新(同步表有延迟,处置前先刷新确认)
        handleRefreshDeduct(row) {
            getAjefCertificateRecordSubUnknownRefresh({ acrId: row.acrId }).then((res) => {
                if (!res || !res.data) {
                    return;
                }
                this.$set(row, 'deductStatusDes', res.data.deductStatusDes);
                this.$set(row, 'resolveAdviceDes', res.data.resolveAdviceDes);
                this.$set(row, 'specsName', res.data.specsName);
                this.$set(row, 'couponSourceDes', res.data.couponSourceDes);
                this.$message.success("扣减记录已刷新");
            });
        },
        getList() {
            this.tableLoading = true;
            const params = { ...this.formDatas };
            // 商户维度 Integer 筛选参数空值不提交,避免后端类型转换失败
            ['ascId', 'ascdId', 'asId'].forEach(k => {
                if (params[k] === '' || params[k] === null) delete params[k];
            });
            getAjefCertificateRecordSubList(params).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        // 城市选择变化时加载区县
        cityChange(ascId) {
            this.formDatas.ascdId = '';
            this.getAjefShopCityDistrictList_data = [];
            if (ascId) {
                this.loadDistrictList(ascId);
            }
            this.partserch();
        },
        // 加载区县列表
        loadDistrictList(ascId) {
            getAjefShopCityDistrictList({ ascId: ascId }).then(res => {
                this.getAjefShopCityDistrictList_data = res.data || [];
            });
        },
        // 退款操作
        handleRefund(row) {
            this.$confirm('确定要退款吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                updateAjefCertificateRecordSubRefund({ acrId: row.acrId }).then((res) => {
                    this.$message.success('退款成功');
                    this.getList();
                }).catch(() => {
                    this.$message.error('退款失败');
                });
            }).catch(() => {});
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
